import React, { useEffect } from "react";
import './css/policy.css'

const Cookies = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    

    return (
        <div className="policy-body">
            <h2>Cookies Policy</h2>
            <p>Effective Date: 30-Sep-2022</p>
            <p>Last Updated: 30-Sep-2022</p>

            <h3>What are cookies?</h3>
            <p>This Cookie Policy explains what cookies are and how we use them, the types of cookies we use i.e, the information we collect using cookies and how that information is used, and how to manage the cookie settings.

                Cookies are small text files that are used to store small pieces of information. They are stored on your device when the website is loaded on your browser. These cookies help us make the website function properly, make it more secure, provide a better user experience, understand how the website performs and analyse what works and where it needs improvement.
            </p>
            <h3>How do we use cookies?</h3>
            <p>As with most online services, our website uses first-party and third-party cookies for several purposes. First-party cookies are primarily necessary for the website to function correctly, and they do not collect any of your personally identifiable data.

                The third-party cookies used on our website are mainly for understanding how the website performs, how you interact with our website, keeping our services secure, providing advertisements that are relevant to you, and all in all providing you with a better and improved user experience and help speed up your future interactions with our website.
            </p>
            <h3>Manage cookie preferences</h3>
            <p>
                Cookie Settings

                You can change your cookie preferences at any time by clicking the above text (“cookie settings). This will let you revisit the cookie consent banner and change your preferences or withdraw your consent right away.

                In addition to this, different browsers provide different methods to block and delete cookies used by websites. You can change the settings of your browser to block/delete the cookies. Listed below are the links to the support documents on how to manage and delete cookies from the major web browsers.
            </p>
            <ul>
                <li>Chrome: https://support.google.com/accounts/answer/32050</li>
                <li>Safari: https://support.apple.com/en-in/guide/safari/sfri11471/mac</li>
                <li>Firefox: https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox?redirectslug=delete-cookies-remove-info-websites-stored&redirectlocale=en-US</li>
                <li>Internet Explorer: https://support.microsoft.com/en-us/topic/how-to-delete-cookie-files-in-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc</li>
            </ul>

            <p>
                If you are using any other web browser, please visit your browser’s official support documents.
            </p>
        </div>
    );
};

export default Cookies;
